import { IconProps } from "../../utils/global-types/global-types";

const InfoBtnIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className || "w-[18px] h-[18px]"}
    {...rest}
  >
    <g clipPath="url(#clip0_4191_21884)">
      <path
        fill="currentColor"
        d="M8.999 14.7a5.7 5.7 0 0 1-5.694-5.871A5.69 5.69 0 0 1 9.045 3.3a5.69 5.69 0 0 1 5.653 5.746c-.032 3.136-2.602 5.686-5.7 5.654m.12-6.511c-.577.019-1.093.219-1.57.534a.5.5 0 0 0-.11.097c-.109.133-.071.245.093.288.063.016.127.028.19.047.261.084.332.213.266.484-.162.66-.327 1.32-.486 1.982-.117.49.131.892.602.928.697.054 1.32-.176 1.879-.58a.28.28 0 0 0 .099-.22c-.004-.044-.119-.08-.186-.115-.028-.015-.063-.018-.094-.026-.312-.083-.393-.214-.318-.525.157-.645.323-1.287.469-1.935.035-.153.037-.33-.002-.48-.087-.337-.381-.492-.831-.48m1.45-1.976c.002-.595-.459-1.065-1.046-1.069a1.057 1.057 0 1 0-.007 2.115 1.05 1.05 0 0 0 1.054-1.046"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_4191_21884">
        <path fill="#fff" d="M3 3h12v12H3z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default InfoBtnIcon;
